import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricDeploymentConfig from './metric-deployment-config-model'
import {
  delete_metricDeploymentConfig,
  load_metricDeploymentConfigs,
  store_metricDeploymentConfig,
} from './metricDeploymentConfig-service'

export const LoadMetricDeploymentConfigsAsync = createAsyncThunk<any, any>(
  'composer/load/metricDeploymentConfig',
  async (params: { uid: string }) => {
    return await load_metricDeploymentConfigs(params)
  },
)

export const CreateMetricDeploymentConfigAsync = createAsyncThunk<any, any>(
  'composer/create/metricDeploymentConfig',
  async (params: MetricDeploymentConfig) => {
    return await store_metricDeploymentConfig(params)
  },
)

export const DeleteMetricDeploymentConfigAsync = createAsyncThunk<any, any>(
  'composer/delete/metricDeploymentConfig',
  async (params) => {
    return await delete_metricDeploymentConfig(params)
  },
)
